import Routes from './Routes';
import { useRoutes } from 'react-router-dom';

const shouldRender = (route) => {
    return route.element !== undefined;
}   
const RouteRenderer = () => {
    const validRoutes = Routes.filter(route => shouldRender(route))
    return useRoutes(validRoutes);
}
export default RouteRenderer;